import { Link, useLocation } from "react-router-dom";
import { FilesFromStorage } from "src/api/types";
import { useCallback, useMemo } from "react";
import { isNonProviderView } from "src/utils/isNonProviderView";
import { saveAs } from "file-saver";
import DownloadIcon from "@mui/icons-material/Download";
import { Stack, Typography, Tooltip, IconButton, Box } from "@mui/material";

interface Props {
  file: FilesFromStorage;
  label: string;
}

const FileView = ({ file, label }: Props) => {
  const { pathname } = useLocation();
  const handleDownload = useCallback(() => {
    saveAs(file.url, file.name);
  }, [file.name, file.url]);

  const isNPV = useMemo(() => isNonProviderView(pathname), [pathname]);

  return (
    <Stack key={file.name} width="50%">
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography>{label}</Typography>
        {isNPV ? (
          <Tooltip title="Download">
            <IconButton onClick={handleDownload}>
              <DownloadIcon />
            </IconButton>
          </Tooltip>
        ) : null}
      </Stack>
      <Box>
        <Link to={file.url} target="_blank">
          <img src={file.url} alt={file.name} width={"100%"} />
        </Link>
      </Box>
    </Stack>
  );
};

export default FileView;
